export default {
  state: {
    vulnerabilities: {},
    vulnerabilitiesByPipeline: {}
  },
  mutations: {
    setVulnerability(state, payload) {
      Vue.set(state.vulnerabilities, payload?.vulnerabilityTool, payload?.vulnerability);
    },
    setVulnerabilitiesByPipeline(state, payload) {
      state.vulnerabilitiesByPipeline = { ...payload };
    }
  },
  actions: {
    setVulnerability(state, payload) {
      state.commit('setVulnerability', payload);
    },
    setVulnerabilitiesByPipeline(state, payload) {
      state.commit('setVulnerabilitiesByPipeline', payload);
    }
  },
  getters: {
    getVulnerability: (state) => (vulnerabilityTool) => state.vulnerabilities[vulnerabilityTool] || null,
    getVulnerabilitiesByPipeline(state) {
      return state.vulnerabilitiesByPipeline;
    }
  }
};
